import { getActiveZones } from "./index23.js";
import { LoadMode } from "./index49.js";
import { addThreadsToPolys } from "./index59.js";
import { getThreadContext } from "./index67.js";
import { getThreadsFromBuilding } from "./index68.js";
import { mainThreadToAnatomy } from "./index69.js";
import { DefaultBuilding, RG_TYPE, RgCreate } from "@project-rouge/rg-core";
import { LineV3toLine3, V3toVector3, getLinesFromPolygon, getPolygonArea, getRgObjectsOfType as getRgObjectsOfType$1 } from "@project-rouge/rg-three";
const pipeTailor = ([parent, { aggProps }]) => {
	const plotContextList = [];
	const dataset = aggProps.dataset;
	const siteEdges = getRgObjectsOfType$1(parent, RG_TYPE.Site).map((s) => s.data.polygon).flatMap((p) => getLinesFromPolygon(p).map(LineV3toLine3));
	const zones = getActiveZones(parent, aggProps);
	const context = getThreadContext(dataset);
	const frozenThreadsPerBuilding = getRgObjectsOfType$1(getRgObjectsOfType$1(parent, RG_TYPE.Zone).filter((z) => !zones.includes(z)), RG_TYPE.Building).map((b) => getThreadsFromBuilding(b, context));
	const frozenThreads = frozenThreadsPerBuilding.flat();
	const mainFrozenThreads = frozenThreadsPerBuilding.map((t) => t[0]);
	for (const zone of zones) {
		const plots = getRgObjectsOfType$1(zone, RG_TYPE.Plot);
		const aggZoneProps = aggProps.zones[zone.uuid];
		for (const plot of plots) {
			const plotContext = {
				plot,
				context: getThreadContext(dataset, {
					aggProps,
					aggZoneProps,
					plotPoly: plot.data.polygon.slice(),
					siteEdges
				}),
				mainThreads: [],
				poly: plot.data.polygon.map(V3toVector3),
				holes: zone.data.holes.map((v) => v.map(V3toVector3))
			};
			plotContextList.push(plotContext);
		}
	}
	plotContextList.sort((a, b) => getPolygonArea(a.plot.data.polygon) - getPolygonArea(b.plot.data.polygon));
	const mainThreads = [];
	let leftThreads = frozenThreads;
	let result;
	do {
		result = addThreadsToPolys({
			plotContextList,
			loadMode: LoadMode.dynamic,
			frozenThreads: leftThreads,
			unboundedTailor: aggProps.unboundedTailor
		});
		for (let i = 0; i < result.mainThreads.length; i++) {
			const thread = result.mainThreads[i];
			const plotContext = plotContextList[i];
			if (!thread) {
				plotContext.poly = [];
				continue;
			}
			plotContext.poly = thread.data.boundary;
			if (thread.data.holes.length === plotContext.holes.length) continue;
			plotContext.holes = thread.data.holes;
		}
		leftThreads = result.threads.map((t) => t.data);
		mainThreads.push(...result.mainThreads);
	} while (aggProps.unboundedTailor && result.mainThreads.filter((t) => t).length);
	for (const mainThread of mainThreads) {
		if (!mainThread) continue;
		plotContextList[mainThread.data.plotIndex].mainThreads.push(mainThread);
	}
	for (const { mainThreads: mainThreads$1, plot, context: context$1 } of plotContextList) for (const mainThread of mainThreads$1) {
		if (!mainThread) continue;
		const joint = mainThreadToAnatomy(mainThread.data, context$1.floors);
		const building = RgCreate({
			...DefaultBuilding,
			parent: plot
		}, dataset.rvData);
		building.data.anatomy = joint;
		plot.children.push(building);
	}
	return [parent, {
		mainThreads: mainThreads.filter((t) => t).map((t) => t.data),
		mainFrozenThreads
	}];
};
export { pipeTailor };

//# sourceMappingURL=index70.js.map